import { Component, EventEmitter, Input } from '@angular/core';
import { isNullOrUndefined } from '@uzurv/core';
import { GenericListMenuHandlerData } from './generic-list-menu-handler-data';

@Component({
  selector: 'app-generic-list-menu',
  templateUrl: './generic-list-menu.component.html',
  styleUrls: ['./generic-list-menu.component.scss']
})
export class GenericListMenuComponent {
  @Input() testingId = null;
  @Input() data: any;
  @Input() label: any;
  @Input() choices: Array<any>;
  @Input() clickHandler: EventEmitter<GenericListMenuHandlerData>;
  @Input() disabled = false;

  handleMenuItemClicked(event: any) {
    if (!isNullOrUndefined(this.clickHandler)) {
      this.clickHandler.emit({ data: this.data, clickEvent: event });
    }
  }
}
